/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlaystationX = createReactComponent("playstation-x", "IconPlaystationX", [
  [
    "path",
    {
      d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M8.5 8.5l7 7", key: "svg-1" }],
  ["path", { d: "M8.5 15.5l7 -7", key: "svg-2" }]
]);

export { IconPlaystationX as default };
//# sourceMappingURL=IconPlaystationX.js.map
